"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRectForDirection = void 0;
var getRectForDirection = function (direction, align, childRect, popupRect, offset) {
    var targetMidX = childRect.left + childRect.width / 2;
    var targetMidY = childRect.top + childRect.height / 2;
    var width = popupRect.width, height = popupRect.height;
    var top;
    var left;
    switch (direction) {
        case 'left':
            top = targetMidY - height / 2;
            left = childRect.left - offset - width;
            if (align === 'start') {
                top = childRect.top;
            }
            if (align === 'end') {
                top = childRect.bottom - height;
            }
            break;
        case 'bottom':
            top = childRect.bottom + offset;
            left = targetMidX - width / 2;
            if (align === 'start') {
                left = childRect.left;
            }
            if (align === 'end') {
                left = childRect.right - width;
            }
            break;
        case 'right':
            top = targetMidY - height / 2;
            left = childRect.right + offset;
            if (align === 'start') {
                top = childRect.top;
            }
            if (align === 'end') {
                top = childRect.bottom - height;
            }
            break;
        default:
            top = childRect.top - height - offset;
            left = targetMidX - width / 2;
            if (align === 'start') {
                left = childRect.left;
            }
            if (align === 'end') {
                left = childRect.right - width;
            }
            break;
    }
    return new DOMRect(left, top, width, height);
};
exports.getRectForDirection = getRectForDirection;
